import { Icon } from '@chakra-ui/react';

export const CustomEditIcon = (props) => (
  <Icon viewBox="0 0 18 17" fill="none" {...props}>
    <path
      d="M11.1029 2.76425L13.9265 5.54691M9.22059 15.75H16.75M1.69118 12.0398L0.75 15.75L4.51471 14.8224L15.4192 4.07581C15.7721 3.72793 15.9703 3.25616 15.9703 2.76425C15.9703 2.27234 15.7721 1.80057 15.4192 1.45269L15.2573 1.29315C14.9043 0.945371 14.4256 0.75 13.9265 0.75C13.4273 0.75 12.9486 0.945371 12.5956 1.29315L1.69118 12.0398Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
